var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loadingData,
          expression: "loadingData",
        },
      ],
      staticClass: "yxtbiz-flip-info",
    },
    [
      _c("div", {}, [
        _c("span", { staticClass: "color-8c" }, [
          _vm._v(
            _vm._s(_vm.$t("pc_biz_o2o_lbl_face_name" /* 面授名称 */)) + "："
          ),
        ]),
        _c("span", { staticClass: "color-26" }, [
          _vm._v(_vm._s(_vm.info.name)),
        ]),
      ]),
      _c("div", { staticClass: "mt16 layout-flex" }, [
        _c("span", { staticClass: "color-8c flex-shrink-0" }, [
          _vm._v(
            _vm._s(_vm.$t("pc_ulcd_lbl_offlinedesc" /* 面授说明 */)) + "："
          ),
        ]),
        _vm.info.description
          ? _c("div", {
              staticClass: "color-26",
              staticStyle: { "margin-top": "-14px" },
              domProps: { innerHTML: _vm._s(_vm.info.description) },
            })
          : _c("span", { staticClass: "color-26" }, [_vm._v("-")]),
      ]),
      _c(
        "div",
        { staticClass: "layout-flex mt16 layout-flex-wrap" },
        _vm._l(_vm.flipLists, function (item, index) {
          return _c(
            "div",
            {
              key: item.id,
              staticClass: "offline-sence-item mr16 mt16 border-box",
            },
            [
              _c(
                "div",
                { staticClass: "color-gray-10 weight-bold lh22 mb16 ellipsis" },
                [
                  _c(
                    "yxt-tooltip",
                    { attrs: { placement: "top", "open-filter": true } },
                    [
                      _c("div", { staticClass: "ellipsis" }, [
                        _c("span", { staticClass: "mr4" }, [
                          _vm._v(
                            _vm._s(_vm.$t("pc_o2o_lbl_sence_no", [index + 1]))
                          ),
                        ]),
                        _vm._v(_vm._s(item.sceneName)),
                      ]),
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("span", { staticClass: "mr4" }, [
                            _vm._v(
                              _vm._s(_vm.$t("pc_o2o_lbl_sence_no", [index + 1]))
                            ),
                          ]),
                          _vm._v(_vm._s(item.sceneName) + "\n          "),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "layout-flex layout-align-center mr32 color-gray-8 over-hidden",
                },
                [
                  _c("yxt-svg", {
                    staticClass: "color-gray-6 mr8 flex-shrink-0",
                    attrs: {
                      "icon-class": "common_time",
                      width: "16px",
                      height: "16px",
                    },
                  }),
                  _c(
                    "yxt-tooltip",
                    {
                      attrs: {
                        placement: "top",
                        content: item.startTime + "~" + item.endTime,
                        "open-filter": true,
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "d-in-block ellipsis color-gray-7" },
                        [_vm._v(_vm._s(item.startTime + "~" + item.endTime))]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "layout-flex layout-align-center mt8 over-hidden",
                },
                [
                  _c("yxt-svg", {
                    staticClass: "color-gray-6 mr8 flex-shrink-0",
                    attrs: {
                      "remote-url":
                        _vm.$staticBaseUrl + "ufd/55a3e0/o2o/pc/svg",
                      width: "16px",
                      height: "16px",
                      "icon-class": "address",
                    },
                  }),
                  _c(
                    "yxt-tooltip",
                    {
                      attrs: {
                        placement: "top",
                        content: item.locationName,
                        "open-filter": true,
                      },
                    },
                    [
                      _c("span", { staticClass: "ellipsis color-gray-7" }, [
                        _vm._v(
                          _vm._s(item.locationName + item.address || "--")
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }